<template>
  <div class="container">
    <h3 class="title">Wybierz urządzenie</h3>
    <div class="btn-group" v-for="(eq, i) in EquipmentTypeList[userData.EquipmentType]" :key="i">
      <button
        type="button"
        class="btn full"
        :style="{ background: $color }"
        @click="btnHandler(eq.k)"
      >{{eq.v}}</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "StepHomeRepairVendor",
  methods: {
    ...mapMutations(["setUserData", "setAssistanceStep"]),
    btnHandler(Vendor) {
      this.setUserData({ Vendor });
      this.setAssistanceStep("homeRepairModel");
    },
  },
  computed: {
    ...mapState(["userData", "EquipmentTypeList"]),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepHomeRepairVendor.vue